import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DefaultResponseWithData } from "../models/system";
import { IVoucher } from "../models/Voucher";
import useApiHelper from "../hooks/useApiHelper";

export function useSupplierVouchers(
    supplierId?: string
  ) {

    const { get } = useApiHelper();

    const vouchers = useQuery<DefaultResponseWithData<IVoucher[]>>({
        queryKey: ['vouchers', 'supplier', supplierId],
        queryFn: () => get(`/voucher/supplier/${supplierId}`),
        enabled: Boolean(supplierId),
      });
  
    return {
        vouchers
    }
}